<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chtitle">Table of Contents</h1>
<p class="toc"><a href="#/B1_Title">The Founding Father<br/>By Diana Palmer</a></p>
<p class="toc1"><span href="#/Title_Page" title="Link target outside of Sample">Justin<br/>By Diana Palmer</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?700a08bf